webpackJsonp([135378372463973],{

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaClose = function FaClose(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.5 29.5q0 0.9-0.7 1.5l-3 3.1q-0.6 0.6-1.5 0.6t-1.5-0.6l-6.6-6.6-6.5 6.6q-0.7 0.6-1.6 0.6t-1.5-0.6l-3-3.1q-0.6-0.6-0.6-1.5t0.6-1.5l6.5-6.6-6.5-6.5q-0.6-0.7-0.6-1.6t0.6-1.5l3-3q0.6-0.6 1.5-0.6t1.6 0.6l6.5 6.6 6.6-6.6q0.6-0.6 1.5-0.6t1.5 0.6l3.1 3q0.6 0.7 0.6 1.5t-0.6 1.6l-6.6 6.5 6.6 6.6q0.6 0.6 0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaClose;
	module.exports = exports['default'];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWhatsapp = function FaWhatsapp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25 21.7q0.3 0 2.2 1t2 1.2q0 0.1 0 0.3 0 0.8-0.4 1.7-0.3 0.9-1.6 1.5t-2.2 0.6q-1.3 0-4.3-1.4-2.2-1-3.8-2.6t-3.3-4.2q-1.6-2.3-1.6-4.3v-0.2q0.1-2 1.7-3.5 0.5-0.5 1.2-0.5 0.1 0 0.4 0t0.4 0.1q0.4 0 0.6 0.1t0.3 0.6q0.2 0.5 0.8 2t0.5 1.7q0 0.5-0.8 1.3t-0.7 1q0 0.2 0.1 0.3 0.7 1.7 2.3 3.1 1.2 1.2 3.3 2.2 0.3 0.2 0.5 0.2 0.4 0 1.2-1.1t1.2-1.1z m-4.5 11.9q2.8 0 5.4-1.1t4.5-3 3-4.5 1.1-5.4-1.1-5.5-3-4.5-4.5-2.9-5.4-1.2-5.5 1.2-4.5 2.9-2.9 4.5-1.2 5.5q0 4.5 2.7 8.2l-1.7 5.2 5.4-1.8q3.5 2.4 7.7 2.4z m0-30.9q3.4 0 6.5 1.4t5.4 3.6 3.5 5.3 1.4 6.6-1.4 6.5-3.5 5.3-5.4 3.6-6.5 1.4q-4.4 0-8.2-2.1l-9.3 3 3-9.1q-2.4-3.9-2.4-8.6 0-3.5 1.4-6.6t3.6-5.3 5.3-3.6 6.6-1.4z' })
	        )
	    );
	};
	
	exports.default = FaWhatsapp;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(46);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _whatsapp = __webpack_require__(52);
	
	var _whatsapp2 = _interopRequireDefault(_whatsapp);
	
	var _close = __webpack_require__(51);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _home = __webpack_require__(53);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Comprar = function Comprar(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'comprar-layout' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      '\xBFC\xF3mo comprar?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Se tramita el pago mediante un dep\xF3sito a la cuenta de ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'b',
	        null,
	        'Fiorella Pattoni Urbina'
	      ),
	      ' en d\xF3lares.'
	    ),
	    _react2.default.createElement('img', { className: 'bac-icon', src: 'https://www.baccredomatic.com/sites/all/themes/custom/foundation_bac/images/bacredomatic_logo.png' }),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Cuenta BAC:'
	        ),
	        ' 922432570 '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'SINPE:'
	        ),
	        ' 10200009224325704'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'C\xE9dula:'
	        ),
	        ' 1-1151-0626'
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'detalles' },
	      _react2.default.createElement(
	        'li',
	        null,
	        '* Especificar en detalle el nombre de la pieza que se quiere adquirir.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '* Enviar comprobante o pantallazo a ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:info@fiorellapattoni.com' },
	          'info@fiorellapattoni.com'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '* Enviar su ubicaci\xF3n al Whatsapp junto con una direcci\xF3n ',
	        _react2.default.createElement('br', null),
	        'de correo electr\xF3nico para confirmar los detalles del env\xEDo.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Se ofrece la opci\xF3n de pagar con dat\xE1fono junto con servicio de mensajeria.',
	      _react2.default.createElement('br', null),
	      'Coordinar detalles al email ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:info@fiorellapattoni.com' },
	        'info@fiorellapattoni.com'
	      ),
	      ' o por Whatsapp.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { 'class': 'nav-content' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'tabs' },
	        _react2.default.createElement(
	          'li',
	          { className: 'tab' },
	          _react2.default.createElement(
	            'a',
	            { href: 'whatsapp://send?abid=+50683075982' },
	            _react2.default.createElement(_whatsapp2.default, null),
	            ' Whatsapp: 8307-5983'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'tab' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            _react2.default.createElement(_home2.default, null),
	            ' Inicio'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'tab' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: 'acerca-de' },
	            'Acerce de mi'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Comprar;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-comprar-js-8eb95d84c7e3f7eeb939.js